import { registerComponent } from '@gig/magic-common';
import SweepstakesTooltipComponent from './sweepstakes-tooltip.vue.js';

var SweepstakesTooltip = registerComponent(SweepstakesTooltipComponent);

export { SweepstakesTooltip };
